export enum ROUTE {
  ACQUISITION_ACTIVITY = '/acquisition/activity',
  ACQUISITION_APPTRACKER = '/acquisition/apptracker',
  ACQUISITION_APPTRACKER_CHANNELS = '/acquisition/apptracker/channels',
  ACQUISITION_APPTRACKER_PROVIDER_VIEW = '/acquisition/apptracker-provider-view',
  ACQUISITION_INSTALLS = '/acquisition/installs',
  ACQUISITION_POWLINKS = '/acquisition/powlinks',
  ACQUISITION_LINKS = '/acquisition/links',
  ACQUISITION_PROVIDERS = '/acquisition/providers',
  ACQUISITION_RETARGETING = '/acquisition/retargeting',
  ACQUISITION_TRACKERS = '/acquisition/trackers',
  ACQUISITION_UNINSTALLS = '/acquisition/uninstalls',
  ACQUISITION_SKADNETWORK = '/acquisition/skadnetwork',
  ACQUISITION_ASSISTED_INSTALLS = '/acquisition/assisted-installs',
  ADMIN_PROVIDERS = '/admin/providers',
  ADMIN_ROLES = '/admin/roles',
  ADMIN_NATIVE_TEMPLATES = '/admin/native-templates',
  AUTO_LOGIN = '/auto-login',
  BEHAVIOR_COHORTS = '/behavior/cohorts',
  BEHAVIOR_EXPLORE = '/behavior/explore',
  BEHAVIOR_FUNNELS = '/behavior/funnels',
  BEHAVIOR_PEOPLE = '/behavior/people',
  BEHAVIOR_AUDIENCES = '/behavior/audiences',
  BEHAVIOR_EVENTS = '/behavior/events',
  COMMUNICATION_AB_ANALYSIS = '/communication/report/ab-analysis',
  COMMUNICATION_MESSAGING = '/communication/messaging',
  COMMUNICATION_PERFORMANCE_REPORT = '/communication/performance-report',
  COMMUNICATION_PERFORMANCE_HISTOGRAMS = '/communication/performance-histograms',
  COMMUNICATION_REPORT = '/communication/report',
  COMMUNICATION_RULES = '/communication/rules',
  COMMUNICATION_JOURNEYS = '/communication/journeys',
  COMMUNICATION_SALES = '/communication/sales',
  FORGOT_PASSWORD = '/forgot-password',
  INTEGRATIONS = '/manage/integrations',
  LEGACY_ROOT = '/legacy',
  LOGIN = '/login',
  LOGOUT = '/logout',
  MAIN_DASHBOARDS = '/main/dashboards',
  MAIN_EXECUTIVE = '/main/executive',
  MAIN_REPORTS = '/main/reports',
  MANAGE_COMMUNICATION_PARAMETERS = '/manage/communication-parameters',
  MANAGE_EVENTS = '/manage/events',
  MANAGE_MAIL_PROVIDERS = '/manage/mail-providers',
  MANAGE_NATIVE_TEMPLATES = '/manage/native-templates',
  MANAGE_TAGS = '/manage/tags',
  MANAGE_IMPORT_TASK = '/manage/import-task',
  ANTIFRAUD = '/antifraud',
  ANTIFRAUD_TEMPLATES = '/antifraud/templates',
  ANTIFRAUD_REPORT = '/antifraud/report',
  REGISTER = '/register',
  ROOT = '/',
  USER_ACCOUNT = '/user/account',
  USER_ACCOUNT_APPS = '/user/account/apps',
  USER_ACCOUNT_USERS = '/user/account/users',
  USER_ACCOUNT_TEST_DEVICES = '/user/account/test-devices',
  USER_APP = '/user/app',
  USER_PASSWORD = '/user/password',
  USER_PLAN = '/user/plan',
  USER_PROFILE = '/user/profile',
  USER_SETUP = '/user/setup',
  USER_WELCOME = '/user/welcome',
  MANAGE_LANDINGS = '/manage/landings',
  MANAGE_CATEGORIES = '/manage/categories',
  PRODUCTS_SQDO = '/products/sqdo',
  PRODUCTS_SQDO_CLASSIC = '/products/classic/sqdo',
}
